import { render, staticRenderFns } from "./AppSwitch.vue?vue&type=template&id=25ba8d62&scoped=true"
import script from "./AppSwitch.vue?vue&type=script&lang=js"
export * from "./AppSwitch.vue?vue&type=script&lang=js"
import style0 from "./AppSwitch.vue?vue&type=style&index=0&id=25ba8d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ba8d62",
  null
  
)

export default component.exports